import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

import { DotEvent, EventsBar } from "@nens/chakra/components";
import { Breach } from "@nens/threedi/openapi-client";

import { normalizeUrl } from "../../../apiConfiguration";
import { GridCard } from "../../../components/GridCard";
import { fetchWithError } from "../../../utils/query";

interface BreachEventProps {
  simulationDuration: number;
  events?: Breach[];
}

interface PotentialBreachResponse {
  connected_pnt_id: number;
}

const BreachEventContent: FC<{ breach: Breach }> = ({ breach }) => {
  // Potential breaches aren't in Swagger, fetch directly

  const potentialBreachResponse = useQuery({
    queryKey: ["potentialBreachResponse", breach.potentialBreach],
    queryFn: () => fetchWithError(normalizeUrl(breach.potentialBreach!)),
  });

  const data: PotentialBreachResponse = potentialBreachResponse.data;

  return (
    <>
      <p>Initial width: {breach.initialWidth}m</p>
      <p>Maximum breach depth: {breach.maximumBreachDepth}m</p>
      <p>Time to reach max depth: {breach.durationTillMaxDepth}s</p>
      <p>Levee material: {breach.leveeMaterial}</p>
      <p>Line ID: {breach.lineId}</p>
      {data ? <p>Connected point ID: {data.connected_pnt_id}</p> : null}
    </>
  );
};

export const BreachEvents: FC<BreachEventProps> = ({ simulationDuration, events }) => {
  if (!events || !events.length) return null;

  const dotEvents: DotEvent[] = events.map((breachEvent) => {
    return {
      time: breachEvent.offset,
      title: `Breach opened after ${breachEvent.offset}s`,
      content: <BreachEventContent breach={breachEvent} />,
    };
  });

  return (
    <GridCard variant="twocolumns" title="Breaches">
      <EventsBar
        start={0}
        end={simulationDuration}
        dotEvents={dotEvents}
        height="30px"
        blockColor="red.300"
        borderColor="brand.grey.600"
      />
    </GridCard>
  );
};
